module.exports = __webpack_public_path__ + "static/media/steps_icon4.445dd7ca.svg";